module.exports = __webpack_public_path__ + "img/wb.704cef27.jpg";